/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Document_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete this document?" |
*
* @param {Meeting_Document_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_document_delete_title = /** @type {((inputs?: Meeting_Document_Delete_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Document_Delete_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Document verwijderen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer ce document ?")
	return /** @type {LocalizedString} */ ("Delete this document?")
});